import getFormLocal from './getFormLocal';

export default async function checkRequiredFilled(formId) {
  const missingField = [];
  const form = await getFormLocal(formId);
  const sections = form.inspection.children;
  Object.keys(sections).forEach((sectionId) => {
    if (
      typeof sections[sectionId] === 'object' &&
      Object.prototype.hasOwnProperty.call(sections[sectionId], 'children')
    ) {
      const questions = sections[sectionId].children;
      const missingSection = [];
      Object.keys(questions).forEach((questionId) => {
        const question = questions[questionId];
        if (
          'required' in question &&
          question.required &&
          (!('displayed' in question) || question.displayed) &&
          (!('value' in question) || question.value === '' || question.value === [] || question.value === null)
        ) {
          missingSection.push(questionId);
        }
      });
      if (missingSection.length > 0) missingField.push({ [sectionId]: missingSection });
    }
  });

  if (missingField.length > 0) {
    return { formFinished: false, missingField };
  }

  return { formFinished: true, missingField: null };
}
